import { signalStore, withState, patchState, withMethods } from "@ngrx/signals";
import { User } from "../../domain/shared/domain/user.domain";

export interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: null
};

export const UserStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store) => ({
    setUser(user: User | null): void {
      patchState(store, { user });
    },

    clear(): void {
      patchState(store, initialState);
    }
  }))
);
